__turbopack_context__.v({
  "isBold": "label-module-scss-module__2ZXEaW__isBold",
  "label": "label-module-scss-module__2ZXEaW__label",
});
